import { render } from "./FileUploadPage.vue?vue&type=template&id=43d4bb52&ts=true"
import script from "./FileUploadPage.vue?vue&type=script&lang=ts"
export * from "./FileUploadPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__